module.exports = __webpack_public_path__ + "img/card-1.0a7746a7.png";